import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

import './VenueEvent.scss';

export const AdministratorVenueEventLogs = (props) => {
    const dispatch = useDispatch();

    const [venueEventLogs, setVenueEventLogs] = useState([]);
    const [venueEventLogCount, setVenueEventLogCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areVenueEventLogsLoading, setAreVenueEventLogsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const ViewDialogCell = (props) => {  
        const content = props.dataItem[props.field];
        
        return (
            <td>
                {content ? <Button fillMode="link" type={"button"} onClick={() => viewDialog(content)}>View</Button> : ""}
            </td>
        );
    };

    const viewDialog = (content) => {
        setDialogContent(content);
        setShowDialog(true);
    }

    const getVenueEventLogs = (newPageNumber) => {
        setAreVenueEventLogsLoading(true);

        const dataItem = {
            venueEventKey: props.venueEventKey,
            pageNumber: newPageNumber,
        };
    
        fetch(`/api/administrator/venueeventlogs`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreVenueEventLogsLoading(false);                
                setItemsPerPage(result.venueEventLogsPerPage);
                setSkipCount(result.venueEventLogsPerPage * (result.pageNumber - 1));
                setVenueEventLogCount(result.totalVenueEventLogCount);                
                setVenueEventLogs(result.venueEventLogs);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreVenueEventLogsLoading(false);
                setLoadingError(error.message);
            });
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getVenueEventLogs(newPageNumber);
    };

    useEffect(() => {
        if (props.venueEventKey) {
            getVenueEventLogs();
        }
    }, []);

    return (
        <div>
            {areVenueEventLogsLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={venueEventLogs}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={venueEventLogCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column field="dateCreated" title={"Date"} />
                        <Column field="parameterName" title={"Parameter"} />
                        <Column field="oldValue" title={"Old Value"} />
                        <Column field="newValue" title={"New Value"} />                        
                        <Column field="loginName" title={"Login Name"} />
                        <Column field="notes" title={"Notes"} cell={ViewDialogCell} />
                    </Grid>

                    {showDialog === false ? <></> :
                        <Dialog
                            title={"Notes"}
                            onClose={() => setShowDialog(false)}
                            width={"90vw"}
                        >
                            {dialogContent}
                        </Dialog>
                    }
                </>
            ) : <></>)
            }
        </div>
    );
}